export default class NullZoomManager {
    //Public:
    constructor() {
        this.__initZoomState();
    }
    compute() {}

    setCenter(center) {}

    applyAutoFit(nodes) {}

    applyInitialAutoFit(nodes) {}

    getManualZoomFunction() {
        return () => {};
    }

    addOnZoomChangeListener(func) {}

    // Private:
    __initZoomState() {
        let state = {
            x: 0,
            y: 0,
            k: 1,
        };
        this.__setZoomState(state);
    }
    __setZoomState(state) {
        const elementId = this._elementId;
        let chart = document.getElementById(elementId);
        chart.__zoom = state;
    }
}
